import { QueryLevel } from "csi/view/_query/Level";
import declare from "dojo/_base/declare";
import AggregateFromRecipeBaseProductTableMixin from "./AggregateFromRecipeBaseProductTableMixin";
import xml from "csi/xml";

const FORMULATED_MATERIAL_SUBTYPE = "FormulatedMaterialSubtype";
const SUBTYPE = "Subtype";

const AggregateFromRecipeFormulatedMaterialTable = declare(AggregateFromRecipeBaseProductTableMixin, {

	/**
	 * @override
	 * Add filter for selected FormulatedMaterial Type
	 */
	onCreateMainQueryLevel(ql: QueryLevel): void {
		this.modifyQuery(FORMULATED_MATERIAL_SUBTYPE, SUBTYPE, ql);
		const query = ql.serverQuery;
		if (query){
			query.Attr("Special", xml.OP_EQUALS, false);
		}
		this.modifyQueryRemoveParentProduct(ql);
	},
});

export = AggregateFromRecipeFormulatedMaterialTable;